import boApiCaller from "./boApiCaller";

export const contactNewUser = async (data: any) => {
    return boApiCaller.post('api/merchant/customer-support', data);
}